/** One protocol in the list: its name, how far its types have got, and the bar that shows it. */

import { cn } from '@/lib/utils';
import { RollupBar } from './rollup-bar';
import { rollupSummary } from './stage';
import type { ProtocolSummary } from './types';

interface ProtocolRowProps {
	protocol: ProtocolSummary;
	selected: boolean;
	onSelect: (sopId: string) => void;
}

export const ProtocolRow = ({ protocol, selected, onSelect }: ProtocolRowProps) => (
	<button
		type='button'
		onClick={() => onSelect(protocol.sopId)}
		aria-current={selected || undefined}
		className={cn(
			'flex w-full cursor-pointer flex-col gap-2 border-b border-gray-300 px-4 py-3 text-left transition-colors hover:bg-gray-100/60',
			selected && 'bg-gray-100 shadow-[inset_2px_0_0_var(--color-ink)]'
		)}
	>
		<span className='flex items-baseline justify-between gap-3'>
			<span className='min-w-0 flex-1 truncate text-[13px] font-medium capitalize text-text-body'>{protocol.name}</span>
			{protocol.rollup.ready > 0 && (
				<span className='shrink-0 text-[11px] font-medium text-green-600'>{protocol.rollup.ready} to generate</span>
			)}
		</span>
		<RollupBar rollup={protocol.rollup} />
		<span className='text-[11px] text-gray-800'>{rollupSummary(protocol.rollup)}</span>
	</button>
);
